import moment from 'moment';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import {
  fromAnyDateToIsoWeekBgn,
  fromAnyDateToIsoWeekEnd,
  fromAnyDateToZuluWeekBgn,
  fromAnyDateToZuluWeekEnd,
} from 'utils/converters/time/from.util';
import { nowAsIso } from 'utils/date/now.util';
import logger from 'utils/logger.util';

const L = logger('parseDateWeek');

const USE_OFFSET_LOCAL_ZONE = true;

const RE_UNCAPTURED = /^\d{2}W\d{4}$/;
const RE_CAPTURED = /^(\d{2})W(\d{4})$/;

const IS = Object.freeze({ valid: false, empty: false, formatted: false });
const DF = Object.freeze({ bgnIso: '', endIso: '', bgnZulu: '', endZulu: '', years: '', weeks: '', is: IS });

const parseDateWeek = (value) => {
  const empty = value === '' || value === null || value === void 1;

  const trimmed = fromAnyToTrimmed(value);
  const valid = fromAnyToBool(trimmed.match(RE_UNCAPTURED));

  const is = { ...IS, empty, valid, formatted: valid };

  try {
    if (!valid || empty) return { ...DF, raw: value, is };

    // can also use moment(trimmed, 'W[W]YYYY')
    const v = value.match(RE_CAPTURED);
    const weeks = v[1];
    const years = v[2];

    const m = moment(nowAsIso());

    if (USE_OFFSET_LOCAL_ZONE) {
      // a workaround for moment defaulting to UTC zone, not the local one
      const offset = moment.parseZone(nowAsIso()).utcOffset();
      m.utcOffset(offset);
    }

    m.set('weeks', weeks);
    m.set('years', years);

    return {
      bgnIso: valid ? fromAnyDateToIsoWeekBgn(m) : '',
      endIso: valid ? fromAnyDateToIsoWeekEnd(m) : '',
      bgnZulu: valid ? fromAnyDateToZuluWeekBgn(m) : '',
      endZulu: valid ? fromAnyDateToZuluWeekEnd(m) : '',
      raw: value,
      years,
      weeks,
      trimmed,
      is,
    };
  } catch (e) {
    L.warn('()', e);
    return { ...DF, raw: value, is };
  }
};

export default parseDateWeek;
